import * as React from 'react';
import { connect } from 'react-redux';
import { TextField } from '@ane/ui-components/lib/components/TextField';
import { Dropdown } from '@ane/ui-components/lib/components/Dropdown';
import { StepContainer, StepLayouts } from '@ane/ui-components/lib/components/StepContainer';
import { dataSourceCreateComponentsName, getPlaceHolder, getValidateMessage, getValidateCosmosDateTimeDiff, } from '../../utils/DataSourceFormikSettingsUtils';
import { ColumnMultilineKey, DataLocationStorageType, parameterType, } from '../../models/DataSourceDataCommon';
import { CreateStepTitle } from '../CreateWizard/CreateSteps';
import { DetailsListWithCommandBar } from '@ane/ui-components/lib/components/DetailsList/DetailsListWithCommandBar';
import { SelectionMode, Selection } from '@ane/ui-components';
import { FormHeading } from '@ane/ui-components/lib/components/FormHeading';
import { FormSection } from '@ane/ui-components/lib/components/FormSection';
const textStyles = {
    root: { maxWidth: 60, display: 'inline-block' },
};
const mapStateToProps = (state) => {
    return {};
};
const mapDispatchToProps = {};
var defaultParameters;
(function (defaultParameters) {
    defaultParameters["startDateTime"] = "e.g. StartDate";
    defaultParameters["endDateTime"] = "e.g. EndDate";
})(defaultParameters || (defaultParameters = {}));
export class ParametersInfoComponent extends React.Component {
    constructor(props) {
        super(props);
        this._selection = new Selection({
            canSelectItem: (item, index) => {
                var _a, _b;
                if (((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.storageType) === DataLocationStorageType.Cosmos && (index === 0 || index === 1)) {
                    return false;
                }
                else {
                    return true;
                }
            },
        });
    }
    render() {
        var _a, _b, _c, _d;
        const items = [];
        items.push({
            key: 'add-datasource-parameter',
            ariaLabel: 'Add parameter',
            disabled: !!this.props.isReadOnly,
            iconProps: {
                iconName: 'Add',
            },
            name: 'Add parameter',
            onClick: () => {
                var _a, _b, _c, _d, _e, _f;
                let parameterList = [
                    ...(((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.parameterList) ? (_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.parameterList : []),
                    {
                        Name: '',
                        Type: '',
                        Value: '',
                        SampleValue: '',
                        delete: null,
                        required: {
                            Name: 'Required',
                            Type: 'Required',
                            Value: 'Required',
                            SampleValue: '',
                        },
                    },
                ];
                (_f = (_e = this.props.formikProps) === null || _e === void 0 ? void 0 : _e.setFieldValue) === null || _f === void 0 ? void 0 : _f.call(_e, 'parameterList', parameterList, true);
            },
        });
        items.push({
            key: 'delete-datasource-parameter',
            ariaLabel: 'Delete parameter',
            disabled: !!this.props.isReadOnly,
            iconProps: {
                iconName: 'Delete',
            },
            name: 'Delete',
            onClick: () => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                const index = this._selection.getSelectedIndices();
                if (index.length <= 0)
                    return;
                if ((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.parameterList) {
                    let parameterList = [
                        ...(_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.parameterList.slice(0, index[0]),
                        ...(_f = (_e = this.props.formikProps) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.parameterList.slice(index[0] + 1),
                    ];
                    (_h = (_g = this.props.formikProps) === null || _g === void 0 ? void 0 : _g.setFieldValue) === null || _h === void 0 ? void 0 : _h.call(_g, 'parameterList', parameterList, true);
                }
            },
        });
        return (React.createElement(StepContainer, { className: "create-parameters-info-tab", layout: StepLayouts.fullWidth },
            !this.props.isUpdateDataSource && (React.createElement(FormHeading, { pageTitle: CreateStepTitle.Parameters }, "This is where you define parameters of your data source and set default values for them.")),
            React.createElement(FormSection, null,
                React.createElement(DetailsListWithCommandBar, { commandBarProps: { ariaLabel: 'action items for data source parameter list', items: items }, detailsListProps: {
                        selection: this._selection,
                        selectionMode: SelectionMode.single,
                        items: ((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.parameterList) ? (_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.parameterList : [],
                        onRenderItemColumn: (item, index, column) => this._onRenderItemColumn(item, index, column),
                        columns: [
                            {
                                key: ColumnMultilineKey.Name,
                                name: 'Name',
                                minWidth: 100,
                                maxWidth: 150,
                                fieldName: 'Name',
                                data: 'string',
                                isResizable: true,
                            },
                            {
                                key: ColumnMultilineKey.Type,
                                name: 'Type',
                                minWidth: 150,
                                maxWidth: 150,
                                fieldName: 'Type',
                                data: 'string',
                                isResizable: true,
                            },
                            {
                                key: ColumnMultilineKey.Value,
                                name: 'Value',
                                minWidth: 100,
                                maxWidth: 250,
                                fieldName: 'Value',
                                data: 'string',
                                isResizable: true,
                            },
                            {
                                key: ColumnMultilineKey.SampleValue,
                                name: 'Sample value',
                                minWidth: 100,
                                maxWidth: 450,
                                fieldName: 'SampleValue',
                                data: 'string',
                                isResizable: true,
                            },
                        ],
                        defaultSortColumn: '',
                        disableSort: true,
                        ariaLabelForGrid: 'parameters info',
                    } }))));
    }
    _updateStartOrEndDate(updateDateObj) {
        let paramter = updateDateObj.parameterList[updateDateObj.currentPos];
        let columnNewValue = paramter.SampleValue;
        if (updateDateObj.currentPos === updateDateObj.index) {
            columnNewValue = updateDateObj.newValue ? updateDateObj.newValue : '';
        }
        let required = '';
        if (columnNewValue === undefined || '' === columnNewValue.trim()) {
            required = 'Required';
        }
        else {
            required = getValidateMessage(parameterType.CosmosDateNumber, columnNewValue);
        }
        if ('' === required) {
            const start = updateDateObj.index === 0 ? updateDateObj.newValue : updateDateObj.parameterList[0].SampleValue;
            const end = updateDateObj.index === 1 ? updateDateObj.newValue : updateDateObj.parameterList[1].SampleValue;
            required = getValidateCosmosDateTimeDiff(start, end);
        }
        updateDateObj.parameterList = [
            ...updateDateObj.parameterList.slice(0, updateDateObj.currentPos),
            {
                ...paramter,
                [updateDateObj.column.key]: columnNewValue,
                required: {
                    ...paramter.required,
                    [updateDateObj.column.key]: required,
                },
            },
            ...updateDateObj.parameterList.slice(updateDateObj.currentPos + 1),
        ];
        return updateDateObj.parameterList;
    }
    _genCosmosStartEndDateValue(item, fieldName, index, column) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (ColumnMultilineKey.Value === fieldName) {
            return (React.createElement("div", null, `${((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.parameterList) && ((_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.parameterList[index][column.key])}`));
        }
        else if (ColumnMultilineKey.SampleValue === fieldName) {
            return (React.createElement("div", { style: { display: 'flex' } },
                "today(\u00A0\"",
                React.createElement(TextField, { styles: textStyles, value: `${(_f = (_e = this.props.formikProps) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.parameterList[index][column.key]}`, ariaLabel: `Parameter ${column.key}`, errorMessage: `${((_h = (_g = this.props.formikProps) === null || _g === void 0 ? void 0 : _g.values) === null || _h === void 0 ? void 0 : _h.parameterList) &&
                        (((_k = (_j = this.props.formikProps) === null || _j === void 0 ? void 0 : _j.touched) === null || _k === void 0 ? void 0 : _k.parameterList)
                            ? (_m = (_l = this.props.formikProps) === null || _l === void 0 ? void 0 : _l.values) === null || _m === void 0 ? void 0 : _m.parameterList[index]['required'][column.key]
                            : '')}`, isReadOnly: !!this.props.isReadOnly, onChange: (props, newValue) => {
                        var _a, _b, _c, _d, _e, _f;
                        let parameterList = ((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.parameterList)
                            ? (_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.parameterList
                            : [];
                        if (parameterList[0] && parameterList[1]) {
                            // Need check both start date and end date
                            let i = index;
                            parameterList = this._updateStartOrEndDate({
                                parameterList: parameterList,
                                newValue: newValue,
                                column: column,
                                currentPos: i,
                                index: index,
                            });
                            parameterList = this._updateStartOrEndDate({
                                parameterList: parameterList,
                                newValue: newValue,
                                column: column,
                                currentPos: i === 0 ? 1 : 0,
                                index: index,
                            });
                            (_f = (_e = this.props.formikProps) === null || _e === void 0 ? void 0 : _e.setFieldValue) === null || _f === void 0 ? void 0 : _f.call(_e, 'parameterList', parameterList, true);
                        }
                    } }),
                "\"\u00A0)"));
        }
    }
    _onRenderItemColumn(item, index, column) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        const { fieldName = '' } = column || {};
        if (!column || !fieldName || index === undefined)
            return null;
        switch (fieldName) {
            case 'Type':
                if (item.placeholder &&
                    (item.placeholder.Name === defaultParameters.startDateTime || item.placeholder.Name === defaultParameters.endDateTime)) {
                    return parameterType.SystemString;
                }
                return (React.createElement(Dropdown, { ariaLabel: `Parameter ${column.key}-${index}`, isReadOnly: !!this.props.isReadOnly, options: [
                        { key: parameterType.SystemString, text: parameterType.SystemString },
                        { key: parameterType.SystemBoolean, text: parameterType.SystemBoolean },
                        { key: parameterType.SystemInt32, text: parameterType.SystemInt32 },
                        { key: parameterType.SystemInt64, text: parameterType.SystemInt64 },
                        { key: parameterType.SystemDouble, text: parameterType.SystemDouble },
                    ], required: true, styles: { root: { paddingRight: '9px' } }, placeholder: getPlaceHolder(dataSourceCreateComponentsName.parametersinfo, column.key), errorMessage: `${((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.parameterList) &&
                        (((_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.touched) === null || _d === void 0 ? void 0 : _d.parameterList)
                            ? (_f = (_e = this.props.formikProps) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.parameterList[index]['required'][column.key]
                            : '')}`, selectedKey: ((_h = (_g = this.props.formikProps) === null || _g === void 0 ? void 0 : _g.values) === null || _h === void 0 ? void 0 : _h.parameterList)
                        ? (_k = (_j = this.props.formikProps) === null || _j === void 0 ? void 0 : _j.values) === null || _k === void 0 ? void 0 : _k.parameterList[index][column.key]
                        : '', onChange: (ev, option) => {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
                        if (!option) {
                            return;
                        }
                        let newValue = option === null || option === void 0 ? void 0 : option.text;
                        let parameterList = ((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.parameterList)
                            ? (_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.parameterList
                            : [];
                        if (parameterList[index]) {
                            let paramter = parameterList[index];
                            let columnNewValue = newValue ? newValue : '';
                            let required = '';
                            if (newValue === undefined || '' === newValue.trim()) {
                                required = 'Required';
                            }
                            let validateValue = '';
                            let validateSample = '';
                            if (paramter.Value === undefined || '' === paramter.Value.trim()) {
                                validateValue = 'Required';
                            }
                            else {
                                if (((_f = (_e = this.props.formikProps) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.storageType) !== DataLocationStorageType.AzureBlob ||
                                    newValue !== parameterType.SystemString) {
                                    validateValue = getValidateMessage(newValue, paramter.Value);
                                }
                            }
                            if (paramter.SampleValue && '' !== paramter.SampleValue.trim()) {
                                if (((_h = (_g = this.props.formikProps) === null || _g === void 0 ? void 0 : _g.values) === null || _h === void 0 ? void 0 : _h.storageType) !== DataLocationStorageType.AzureBlob ||
                                    newValue !== parameterType.SystemString) {
                                    validateSample = getValidateMessage(newValue, paramter.SampleValue);
                                }
                            }
                            if ((_k = (_j = this.props.formikProps) === null || _j === void 0 ? void 0 : _j.values) === null || _k === void 0 ? void 0 : _k.parameterList) {
                                parameterList = [
                                    ...(_m = (_l = this.props.formikProps) === null || _l === void 0 ? void 0 : _l.values) === null || _m === void 0 ? void 0 : _m.parameterList.slice(0, index),
                                    {
                                        ...paramter,
                                        [column.key]: columnNewValue,
                                        required: {
                                            ...paramter.required,
                                            Value: validateValue,
                                            SampleValue: validateSample,
                                            [column.key]: required,
                                        },
                                    },
                                    ...(_p = (_o = this.props.formikProps) === null || _o === void 0 ? void 0 : _o.values) === null || _p === void 0 ? void 0 : _p.parameterList.slice(index + 1),
                                ];
                            }
                            else {
                                parameterList = [];
                            }
                            (_r = (_q = this.props.formikProps) === null || _q === void 0 ? void 0 : _q.setFieldValue) === null || _r === void 0 ? void 0 : _r.call(_q, 'parameterList', parameterList, true);
                        }
                    } }));
            default:
                if (item.placeholder &&
                    (item.placeholder.Name === defaultParameters.startDateTime ||
                        item.placeholder.Name === defaultParameters.endDateTime) &&
                    fieldName !== 'Name' &&
                    fieldName !== 'delete') {
                    return this._genCosmosStartEndDateValue(item, fieldName, index, column);
                }
                else
                    return (React.createElement(TextField, { value: `${((_m = (_l = this.props.formikProps) === null || _l === void 0 ? void 0 : _l.values) === null || _m === void 0 ? void 0 : _m.parameterList) && ((_p = (_o = this.props.formikProps) === null || _o === void 0 ? void 0 : _o.values) === null || _p === void 0 ? void 0 : _p.parameterList[index][column.key])}`, ariaLabel: `Parameter ${column.key}`, isReadOnly: !!this.props.isReadOnly, description: ((_r = (_q = this.props.formikProps) === null || _q === void 0 ? void 0 : _q.values) === null || _r === void 0 ? void 0 : _r.parameterList) &&
                            ((_t = (_s = this.props.formikProps) === null || _s === void 0 ? void 0 : _s.values) === null || _t === void 0 ? void 0 : _t.parameterList[index]) &&
                            ((_v = (_u = this.props.formikProps) === null || _u === void 0 ? void 0 : _u.values) === null || _v === void 0 ? void 0 : _v.parameterList[index]['placeholder'])
                            ? (_x = (_w = this.props.formikProps) === null || _w === void 0 ? void 0 : _w.values) === null || _x === void 0 ? void 0 : _x.parameterList[index]['placeholder'][column.key]
                            : getPlaceHolder(dataSourceCreateComponentsName.parametersinfo, column.key), required: column.key === ColumnMultilineKey.SampleValue ? false : true, multiline: column.key === ColumnMultilineKey.Value || column.key === ColumnMultilineKey.SampleValue ? true : false, onKeyDownCapture: (event) => {
                            var _a, _b, _c, _d;
                            const length = ((_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.parameterList)
                                ? ((_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.parameterList[index][column.key]).length
                                : 0;
                            // ArrowLeft: 37 ArrowUp: 38
                            if (event.keyCode === 37 || event.keyCode === 38) {
                                if (event.currentTarget.selectionStart !== null && event.currentTarget.selectionStart > 0) {
                                    event.stopPropagation();
                                }
                            }
                            // ArrowRight: 39 ArrowDown: 40
                            if (event.keyCode === 39 || event.keyCode === 40) {
                                if (event.currentTarget.selectionEnd !== null && event.currentTarget.selectionEnd < length) {
                                    event.stopPropagation();
                                }
                            }
                        }, errorMessage: `${((_z = (_y = this.props.formikProps) === null || _y === void 0 ? void 0 : _y.values) === null || _z === void 0 ? void 0 : _z.parameterList) &&
                            (((_1 = (_0 = this.props.formikProps) === null || _0 === void 0 ? void 0 : _0.touched) === null || _1 === void 0 ? void 0 : _1.parameterList)
                                ? (_3 = (_2 = this.props.formikProps) === null || _2 === void 0 ? void 0 : _2.values) === null || _3 === void 0 ? void 0 : _3.parameterList[index]['required'][column.key]
                                : '')}`, onChange: (props, newValue) => {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                            let parameterList = (_b = (_a = this.props.formikProps) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.parameterList;
                            if (parameterList[index]) {
                                let paramter = parameterList[index];
                                let columnNewValue = newValue ? newValue : '';
                                let required = '';
                                if ((newValue === undefined || '' === newValue.trim()) && column.key !== ColumnMultilineKey.SampleValue) {
                                    required = 'Required';
                                }
                                if (column.key === ColumnMultilineKey.Value ||
                                    (column.key === ColumnMultilineKey.SampleValue && columnNewValue !== '')) {
                                    if (((_d = (_c = this.props.formikProps) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.storageType) !== DataLocationStorageType.AzureBlob ||
                                        item.Type !== parameterType.SystemString) {
                                        required = getValidateMessage(item.Type, columnNewValue);
                                    }
                                }
                                if ((_f = (_e = this.props.formikProps) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.parameterList) {
                                    parameterList = [
                                        ...(_h = (_g = this.props.formikProps) === null || _g === void 0 ? void 0 : _g.values) === null || _h === void 0 ? void 0 : _h.parameterList.slice(0, index),
                                        {
                                            ...paramter,
                                            [column.key]: columnNewValue,
                                            required: {
                                                ...paramter.required,
                                                [column.key]: required,
                                            },
                                        },
                                        ...(_k = (_j = this.props.formikProps) === null || _j === void 0 ? void 0 : _j.values) === null || _k === void 0 ? void 0 : _k.parameterList.slice(index + 1),
                                    ];
                                }
                                else {
                                    parameterList = [];
                                }
                                (_m = (_l = this.props.formikProps) === null || _l === void 0 ? void 0 : _l.setFieldValue) === null || _m === void 0 ? void 0 : _m.call(_l, 'parameterList', parameterList, true);
                            }
                        } }));
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ParametersInfoComponent);

//# sourceMappingURL=ParametersInfoComponent.js.map
